import { ReactComponent as TaskArrowIcon } from 'assets/icons/taskArrow.svg';
import formattedData from 'utils/formattedData';

import type { ITaskInfoActivityDateItem } from './interfaces/ITaskInfoActivityDateItem';

import styles from './sass/TaskInfoActivityDateItem.module.scss';

function TaskInfoActivityDateItem({
  title,
  beforeDate,
  afterDate,
}: ITaskInfoActivityDateItem) {
  return (
    <div className={styles.itemContainer}>
      <span className={styles.itemContainerTitle}>
        {title}
      </span>
      <div className={styles.itemContainerValue}>
        {beforeDate ? (
          <span className={styles.textValue}>
            {formattedData(beforeDate)}
          </span>
        ) : null}
        {beforeDate && afterDate ? <TaskArrowIcon /> : null}
        {afterDate ? (
          <span className={styles.textValue}>
            {formattedData(afterDate)}
          </span>
        ) : null}
      </div>
    </div>
  );
}

export default TaskInfoActivityDateItem;
